import React from 'react';

import styles from './MonitorSectionTitle.module.scss';

interface IMonitorSectionTitleProps {
    title: string,
    name?: string,
}

const MonitorSectionTitle: React.FC<IMonitorSectionTitleProps> = ({title, name}) => (
    <div className={styles.titleBlock}>
        <h3 className={styles.title}>
            <span>{title}</span>
            {name && <span className={styles.name}>{name}</span>}
        </h3>
    </div>
);

export default MonitorSectionTitle;
